import { AnyAction } from '@reduxjs/toolkit'
import { Epic } from 'redux-observable'
import { of, from } from 'rxjs'
import { switchMap, map, catchError, withLatestFrom, filter } from 'rxjs/operators'

import { fetchTariffs, fetchTariffsSuccess, fetchTariffsError } from './tariff.reducer'

import TariffService from '../services/tariff.service'

import { RootState } from '~/core/store/root.reducer'

export interface ServiceErrorInterface {
  response: {
    data: {
      code: number
      status: string
      message: string
      detailMsg: string
    }
  }
}

export const fetchTariffDataEpic: Epic<
  AnyAction,
  AnyAction,
  RootState,
  { tariffService: TariffService }
> = (action$, state$, { tariffService }) =>
  action$.pipe(
    filter(fetchTariffs.match),
    withLatestFrom(state$),
    switchMap(([action]) =>
      from(tariffService.fetchTariffs(action.payload.params)).pipe(
        map((result) => fetchTariffsSuccess({ tariffs: result, id: action.payload.id })),
        catchError((error: ServiceErrorInterface) =>
          of(
            fetchTariffsError({
              errorCode: error?.response?.data?.code || 0,
              errorMessage: error?.response?.data?.detailMsg || 'No response',
              id: action.payload.id,
            }),
          ),
        ),
      ),
    ),
  )

export default {
  fetchTariffDataEpic,
}
